"use client";

import Image from "next/image";
import ScrollReveal from "./ScrollReveal";

interface PageBannerProps {
    imageSrc: string;
    alt?: string;
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
}

export default function PageBanner({
    imageSrc,
    alt,
    title,
    subtitle,
    children,
}: PageBannerProps) {
    return (
        <section className="relative h-[50vh] min-h-[500px] flex items-center justify-center overflow-hidden bg-black">
            <Image
                src={imageSrc}
                alt={alt || title}
                fill
                className="object-cover opacity-60"
                sizes="100vw"
                priority
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-light dark:from-background-dark via-transparent to-transparent opacity-100" />

            <div className="relative z-10 text-center px-4 animate-fade-up">
                <ScrollReveal>
                    <h1 className="text-5xl md:text-8xl font-display uppercase text-white drop-shadow-2xl leading-none">
                        {title}
                    </h1>
                    {subtitle ? (
                        <p className="mt-4 text-xl md:text-2xl font-accent text-primary uppercase tracking-widest font-bold drop-shadow-md">
                            {subtitle}
                        </p>
                    ) : (
                        <div className="w-24 h-1 bg-primary mx-auto mt-4 shadow-lg" />
                    )}
                    {children}
                </ScrollReveal>
            </div>
        </section>
    );
}
